import {AbstractListService, DestroyStreamService} from "../../services";
import {IntListDisplayDataExtractionService} from "./int-list-display-data-extraction.service";
import {IntFilterPayloadFormatterService, IntGetDateInfoDependFormatService} from "./int-filter-payload.service";
import {IntTableSortingService} from "../int-table-sorting";

export const INT_LIST_DISPLAY_DATA_EXTRACTION_PROVIDER = [
  DestroyStreamService,
  IntListDisplayDataExtractionService,
  IntFilterPayloadFormatterService,
  AbstractListService,
  IntTableSortingService,
  IntGetDateInfoDependFormatService,
];
